export const SET_LOADING_USERS_PROJECT_START = 'SET_LOADING_USERS_PROJECT_START'
export const GET_USERS_PROJECT_SUCCESS = 'GET_USERS_PROJECT_SUCCESS'
export const GET_USERS_PROJECT_FAILED = 'GET_USERS_PROJECT_FAILED'
export const GET_ALL_PROJECT_USERS_SUCCESS = 'GET_ALL_PROJECT_USERS_SUCCESS'
export const ADD_PROJECT_USERS = 'ADD_PROJECT_USERS'